<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="close">
        <div class="modal-container" @click.stop>
          <div class="grid-container genderSelection">
            <button class="close" @click="close"></button>
            <div class="grid-x">
              <div class="small-12 colums text-center">
                <p><small class="tit">Velg hvor mye du drikker</small></p>
              </div>
              <div class="small-6 colums text-center">
                <div v-if="getLittleAlcohols.length > 0">
                  <input
                    v-model="item.alcohol"
                    id="alcoholLittle"
                    name="alcohol"
                    type="radio"
                    value="1"
                    @change="close"
                  /><a class="bgicon" href="#" @click="check(1)"><label for="alcoholLittle"
                    ><span class="icon drinkend standingbottles fill"></span
                    ><span>Moderat</span></label
                  ></a>
                </div>
              </div>
              <div class="small-6 colums text-center">
                <div v-if="getLotsAlcohols.length > 0">
                  <input
                    v-model="item.alcohol"
                    id="alcoholLots"
                    name="alcohol"
                    type="radio"
                    value="2"
                    @change="close"
                  /><a class="bgicon" href="#" @click="check(2)"><label for="alcoholLots"
                    ><span
                      class="icon drinkstart standingandlyingbottle fill"
                    ></span
                    ><span>Mye</span></label
                  ></a>
                </div>
              </div>
              <div
                class="small-12 colums text-center flex--medium flex--center of--visible"
                style="margin-top:20px"
                v-if="item.alcohol != 0"
              >
                <input
                  class="mb--0 ng-untouched ng-valid ng-dirty"
                  id="alcoholNone"
                  name="alcohol"
                  type="radio"
                  v-model="item.alcohol"
                  value="0"
                  @change="close"
                /><a class="bgicon" href="#" @click="check(0)"><label class="none" for="alcoholNone"
                  ><span>Fjern valg </span>
                </label></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    item: Object,
  },

  computed: {
    ...mapGetters(["getLotsAlcohols", "getLittleAlcohols"]),
  },
  data() {
    return {
      id: null,
      day: null,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    check(num){
      this.item.alcohol = num
      this.close()
    }
  },
  mounted() {
    this.day = this.item;
  },
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  color: #fff;
  width: 311px;
  margin: 0px auto;
  padding: 20px 0px;
  background-color: #3a3c8a;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  .close {
    position: absolute;
    right: 0px;
    top: -20px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    &:before,
    &:after {
      width: 20px;
    }
  }
  .genderSelection {
    position: relative;
    padding-top: 2rem;
    padding-bottom: 1rem;
    label {
      &.none {
        text-decoration: underline;
      }
      padding: 1rem;
      width: 100%;
      border-radius: 2px;
      color: #fff;
      &:hover {
        background-color: #515195;
      }
      margin-left: 0;
    }
    [type="radio"] + label {
      max-width: calc(100% - 20px);
    }
    input[type="radio"]:checked + label {
      border: 0;
      background-color: #515195;
    }
    small.tit {
      font-size: 16px;
    }
  }
  .icon.fill {
    max-width: 100%;
    padding-bottom: 100%;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.small-6 .bgicon{
text-decoration:none;
}
.bgicon{
  display:block;
  
}
.bgicon:focus-visible{
  background-color:#515195
}
</style>
